document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-vpg-section]').forEach(function(sectionEl) {
    if (sectionEl.dataset.vpgInitialized === 'true') return;
    sectionEl.dataset.vpgInitialized = 'true';

    const body = document.body;

    function pauseAllModalVideos() {
      sectionEl.querySelectorAll('.vpg-modal video').forEach(function(video) {
        try {
          video.pause();
        } catch(e) {}
      });
    }

    function playModalVideo(modal) {
      const video = modal.querySelector('.vpg-modal video');
      if (!video) return;

      try {
        video.currentTime = 0;
        video.muted = true;

        const playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function() {});
        }
      } catch(e) {}
    }

    function openModal(id) {
      const modal = document.getElementById(id);
      if (!modal) return;

      pauseAllModalVideos();

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      body.style.overflow = 'hidden';

      playModalVideo(modal);
    }

    function closeModal(modal) {
      if (!modal) return;

      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');

      pauseAllModalVideos();
      body.style.overflow = '';
    }

    sectionEl.querySelectorAll('[data-modal-target]').forEach(function(card) {
      const targetId = card.getAttribute('data-modal-target');

      card.querySelectorAll('.vpg-media-btn, .vpg-product-card').forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          openModal(targetId);
        });
      });
    });

    sectionEl.querySelectorAll('.vpg-modal').forEach(function(modal) {
      modal.querySelectorAll('[data-close-modal]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          closeModal(modal);
        });
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;

      const opened = sectionEl.querySelector('.vpg-modal.is-open');
      if (opened) closeModal(opened);
    });

    sectionEl.querySelectorAll('[data-product-form]').forEach(function(form) {
      const blockId = form.getAttribute('data-block-id');
      const variantsJson = form.querySelector('.vpg-variants-json');
      const variantInput = form.querySelector('[data-variant-id-input]');
      const priceEl = document.getElementById('modalPrice-' + blockId);
      const compareEl = document.getElementById('modalCompare-' + blockId);
      const imageEl = document.getElementById('modalImage-' + blockId);
      const resultEl = form.querySelector('[data-add-result]');
      const addBtn = form.querySelector('.vpg-add-btn');
      const optionGroups = form.querySelectorAll('.vpg-option-values');

      if (!variantsJson || !variantInput || !priceEl || !compareEl || !addBtn) return;

      let variants = [];

      try {
        variants = JSON.parse(variantsJson.textContent);
      } catch(e) {
        variants = [];
      }

      function getSelectedOptions() {
        return Array.from(optionGroups).map(function(group) {
          const active = group.querySelector('.vpg-option-btn.is-active');
          return active ? active.getAttribute('data-option-value') : null;
        });
      }

      function findVariant() {
        const selected = getSelectedOptions();

        return variants.find(function(variant) {
          return variant.options.every(function(optionValue, index) {
            return optionValue === selected[index];
          });
        });
      }

      function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function updateVariantUI() {
        const matched = findVariant();
        if (!matched) return;

        variantInput.value = matched.id;
        priceEl.textContent = formatMoney(matched.price);

        if (matched.compare_at_price && matched.compare_at_price > matched.price) {
          compareEl.style.display = '';
          compareEl.textContent = formatMoney(matched.compare_at_price);
        } else {
          compareEl.style.display = 'none';
          compareEl.textContent = '';
        }

        if (imageEl && matched.featured_image) {
          imageEl.src = matched.featured_image;
        }

        addBtn.disabled = !matched.available;
        addBtn.textContent = matched.available ? 'Add to Cart' : 'Sold Out';
      }

      form.querySelectorAll('.vpg-option-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const group = btn.closest('.vpg-option-values');
          if (!group) return;

          group.querySelectorAll('.vpg-option-btn').forEach(function(sibling) {
            sibling.classList.remove('is-active');
          });

          btn.classList.add('is-active');
          updateVariantUI();
        });
      });

      updateVariantUI();

      form.addEventListener('submit', function(e) {
        e.preventDefault();

        if (!resultEl) return;

        resultEl.textContent = '';
        addBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantInput.value),
            quantity: 1
          })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function() {
          resultEl.textContent = 'Added to cart';

          const matched = findVariant();
          addBtn.disabled = !(matched && matched.available);
        })
        .catch(function() {
          resultEl.textContent = 'Unable to add to cart';

          const matched = findVariant();
          addBtn.disabled = !(matched && matched.available);
        });
      });
    });

    sectionEl.querySelectorAll('video, .vpg-video').forEach(function(video) {
      video.muted = true;
      video.playsInline = true;

      try {
        const playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function() {});
        }
      } catch(e) {}
    });
  });
});